import { render, staticRenderFns } from "./PageCards.vue?vue&type=template&id=02ed534e"
import script from "./PageCards.vue?vue&type=script&lang=js"
export * from "./PageCards.vue?vue&type=script&lang=js"
import style0 from "./PageCards.vue?vue&type=style&index=0&id=02ed534e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports